export const FINANCIAL_STATEMENTS_DEFAULT_PARAMS = {
  offset: 1,
  limit: 20,
  companyName: undefined,
  year: undefined,
  companySize: undefined,
  status: undefined,
};

export const FINANCIAL_STATEMENTS_FILTER_FORM_DEFAULT_PARAMS = {
  companyName: undefined,
  year: undefined,
  companySize: undefined,
  status: undefined,
};
